export enum EOQTypeCode {
  None = 'NONE',
  FixedTime = 'FT',
  FixedQuantity = 'FQ'
}
